// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"8a4a78be","527":"43e66112","910":"41bd8a7e"}[chunkId] + ".chunk.js";
};